<template>
  <ais-configure
    :filters="filters"
    v-if="filters"
  />
</template>

<script>
const permissions = {
  default: 'NOT venue:Cineworld',
  gourmetsociety: "",
  gourmetsociety_plus: "",
  gourmetsociety_eb: "",
  gourmetsociety_b2b: "NOT venue:Cineworld",
};

export default {
  computed: {
    filters() {
      return permissions[this.userType];
    },
    userType() {
      if (window.user_type && permissions[window.user_type] !== undefined) {
        return window.user_type;
      }
      return 'default';
    },
  },
};
</script>
